const EmbeddedVideo = ({ videoUrl }) => (
  <div className="video-responsive">
    <iframe
      src={`${videoUrl}`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen=""
      title="Embedded youtube"
    />
  </div>
)

export default EmbeddedVideo
